import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RideModeProvider } from "@/context/RideModeContext";
import { UnitPreferenceProvider } from "@/context/UnitPreferenceContext";
import { AdminRoute } from "@/components/AdminRoute";
import { OperatorRoute } from "@/components/OperatorRoute";
import { AnalyticsManager } from "@/components/AnalyticsManager";
import { RouteSeo } from "@/components/Seo";
import DiscoverEventsExperience from "@/pages/DiscoverEventsExperience";
import Events from "@/pages/Events";
import RidePlanner from "@/pages/RidePlanner";
import GroupDiscovery from "@/pages/GroupDiscovery";
import RidePlanRoom from "@/pages/RidePlanRoom";
import CompareSpots from "@/pages/CompareSpots";
import AdminEvents from "@/pages/AdminEvents";
import ParkDetail from "@/pages/ParkDetail";
import TrailDetail from "@/pages/TrailDetail";
import Favorites from "@/pages/Favorites";
import PersonalMap from "@/pages/PersonalMap";
import RiderProfile from "@/pages/RiderProfile";
import AddDestination from "@/pages/AddDestination";
import Admin from "@/pages/Admin";
import Operator from "@/pages/Operator";
import { Login, Register, VerifyEmail } from "@/pages/Auth";
import InstallApp from "@/pages/InstallApp";
import { PrivacyPolicy, TermsOfUse, Impressum } from "@/pages/Legal";
import { AppFooter } from "@/components/AppFooter";
import { useLanguage } from "@/i18n/useLanguage";

function AppRouteSeo() {
  const location = useLocation();
  return <RouteSeo pathname={location.pathname} />;
}

function AppFooterBar() {
  return <AppFooter />;
}

function App() {
  useLanguage();
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsManager />
        <AppRouteSeo />
        <AuthProvider>
          <UnitPreferenceProvider>
            <RideModeProvider>
              <Routes>
                <Route path="/" element={<DiscoverEventsExperience />} />
                <Route path="/events" element={<Events />} />
                <Route path="/ride-planner" element={<RidePlanner />} />
                <Route path="/group-discovery" element={<GroupDiscovery />} />
                <Route path="/compare" element={<CompareSpots />} />
                <Route path="/install" element={<InstallApp />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/ride-plan/:shareToken" element={<RidePlanRoom />} />
                <Route path="/park/:id" element={<ParkDetail />} />
                <Route path="/trail/:destinationId/:trailId" element={<TrailDetail />} />
                <Route path="/trail/:id" element={<TrailDetail />} />
                <Route path="/add-destination" element={<AddDestination />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/my-map" element={<PersonalMap />} />
                <Route path="/profile" element={<RiderProfile />} />
                <Route path="/onboarding" element={<Navigate to="/profile?tab=preferences" replace />} />
                <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
                <Route path="/admin/events" element={<AdminRoute><AdminEvents /></AdminRoute>} />
                <Route path="/operator" element={<OperatorRoute><Operator /></OperatorRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
              </Routes>
              <AppFooterBar />
              <Toaster position="top-center" theme="dark" richColors />
            </RideModeProvider>
          </UnitPreferenceProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
